import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CountryPageFooterLinks } from './CountryPageLinks';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
          {/* Company Info */}
          <div className="col-span-1">
            <h4 className="font-semibold text-gray-900 mb-4">ivoliq</h4>
            <p className="text-sm text-gray-600">
              Zeit & Finanzen für Freelancer
            </p>
          </div>
          
          {/* Country Page Links */}
          <CountryPageFooterLinks className="col-span-1" />
          
          {/* Additional Links */}
          <div className="col-span-1">
            <h4 className="font-semibold text-gray-900 mb-4">Tools</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/steuerruecklagen-freelancer" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Steuerrücklagen
                </Link>
              </li>
              <li>
                <Link to="/steuerruecklagen-freelancer-deutschland" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Steuerrücklagen Deutschland
                </Link>
              </li>
              <li>
                <Link to="/steuerruecklagen-freelancer-oesterreich" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Steuerrücklagen Österreich
                </Link>
              </li>
              <li>
                <Link to="/steuerruecklagen-freelancer-schweiz" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Steuerrücklagen Schweiz
                </Link>
              </li>
              <li>
                <Link to="/buchhaltung-freelancer-deutschland" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Buchhaltung
                </Link>
              </li>
              <li>
                <Link to="/zeiterfassung-freelancer" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  Zeiterfassung
                </Link>
              </li>
              <li>
                <Link to="/e-rechnung-freelancer" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-erechnung-link">
                  E-Rechnung (XRechnung & ZUGFeRD)
                </Link>
              </li>
              <li>
                <Link to="/steuerberater-portal" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-sb-portal-link">
                  Steuerberater-Portal
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal Links */}
          <div className="col-span-1">
            <h4 className="font-semibold text-gray-900 mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-pricing-link">
                  {t('footer.pricing', 'Preise')}
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  {t('footer.impressum', 'Impressum')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  {t('footer.privacy', 'Datenschutz')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm">
                  {t('footer.terms', 'AGB')}
                </Link>
              </li>
              <li>
                <Link to="/avv" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-avv-link">
                  {t('footer.avv', 'AVV (Art. 28 DSGVO)')}
                </Link>
              </li>
              <li>
                <Link to="/steuerberater-agb" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-sb-terms-link">
                  SB-Vertrag (Steuerberater)
                </Link>
              </li>
              <li>
                <Link to="/steuerberater-avv" className="text-gray-600 hover:text-emerald-600 transition-colors duration-200 text-sm" data-testid="footer-sb-avv-link">
                  SB-AVV (Steuerberater)
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6 border-t border-gray-200">
          {/* Copyright */}
          <div className="text-sm text-gray-600">
            © {currentYear} ivoliq GmbH · FN 680579 b · Handelsgericht Wien
          </div>

          {/* Cookie Settings */}
          <div className="flex gap-6 text-sm">
            <button
              onClick={() => {
                // Clear localStorage consent to show banner again
                localStorage.removeItem('ivoliq_cookie_consent');
                localStorage.removeItem('analytics-consent');
                localStorage.removeItem('marketing-consent');
                window.location.reload();
              }}
              className="text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer"
            >
              {t('footer.cookieSettings', 'Cookie-Einstellungen')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
